import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@klickdata/core/auth';
import { SideNaveActionsTypes, SideNaveData, SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { ResourceTypes } from '@klickdata/core/resource';
import { AiModelSpecs, MaterialModelType, Resource } from '@klickdata/core/resource/src/resource.model';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-menu-side-ai-prompter',
    templateUrl: './menu-side-ai-prompter.component.html',
    styleUrls: ['./menu-side-ai-prompter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideAiPrompterComponent {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    public model: AiModelSpecs;
    public aiModelType: MaterialModelType = MaterialModelType.TEXT;

    SideNaveActionsTypes = SideNaveActionsTypes;
    public advancedModeSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    constructor(protected router: Router, protected auth: AuthService, protected cdr: ChangeDetectorRef) {}
    onEditMaterial(resource: Resource) {
        this.auth
            .getUser()
            .pipe(first())
            .subscribe((user) => {
                const queryParams = {
                    queryParams: {
                        bypassGuardWithoutSaving: true,
                    },
                };
                this.onClose.emit({ clearCompData: true });
                if (resource.type_id === ResourceTypes.GeneralCoursePlan) {
                    user.isAdmin()
                        ? this.router.navigate(['/admin/content/courses/', resource.id], queryParams)
                        : this.router.navigate(['/home/manage/course-plan/', resource.id], queryParams);
                } else {
                    user.isAdmin()
                        ? this.router.navigate(
                              [`/admin/content/${ResourceTypes.playerRoute(resource.type_id)}s/`, resource.id],
                              queryParams
                          )
                        : this.router.navigate(
                              [`/home/manage/${ResourceTypes.playerRoute(resource.type_id)}/`, resource.id],
                              queryParams
                          );
                }
            });
    }
}
